import Vue from 'vue'
import Router from 'vue-router'
import CallerCalendar from "@/views/rufbereitschaft/CallerCalendar";

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

const Calendar = () => import('@/views/calendar/calendar')
const HolidayCalendar = () => import('@/views/calendar/UrlaubsKalendar')
const Auskunft = () => import('@/views/calendar/Auskunft')

const RufbereitschaftRaster = () => import('@/views/rufbereitschaft/Raster')
const RufbereitschaftCalendar = () => import('@/views/rufbereitschaft/RbCalendar')
const RufbereitschaftSettings = () => import('@/views/rufbereitschaft/RbSettings')
const RufbereitschaftCaller = () => import('@/views/rufbereitschaft/CallerCalendar')
const Anwesenheit = () => import('@/views/zeitkontrolle/Anwesenheit.vue')
const UebVerrechung = () => import('@/views/ueb/UebCalculation.vue')
const UserDay = () => import('@/views/zeitkontrolle/UserDay.vue')
const Azra = () => import('@/views/basis_data/azra_list.vue')
const Breaks = () => import('@/views/basis_data/break_list.vue')
const Migrs = () => import('@/views/basis_data/migr_list.vue')
const Kosts = () => import('@/views/basis_data/kost_list.vue')
const Mitas = () => import('@/views/basis_data/mita_list.vue')
const Lohns = () => import('@/views/basis_data/lohn_list.vue')
const StammdatenImport = () => import('@/views/basis_data/import_export/StammdatenImportPage.vue')
const AzraDetail = () => import('@/views/basis_data/azra_detail.vue')
const DpUebersicht = () => import('@/views/dienstplanung/Uebersicht.vue')
const DpGruppen = () => import('@/views/dienstplanung/Planungsgruppen.vue')
const DpRaster = () => import('@/views/dienstplanung/Arbeitszeitraster.vue')
const DpRotation = () => import('@/views/dienstplanung/Rotation.vue')
const DpZuordnung = () => import('@/views/dienstplanung/Zuordnung.vue')
const DpKalender = () => import('@/views/dienstplanung/Kalender.vue')
const DpBesetzung = () => import('@/views/dienstplanung/Besetzung.vue')
const DpVeroeffentlichen = () => import('@/views/dienstplanung/Veroeffentlichen.vue')
const DpProtokoll = () => import('@/views/dienstplanung/Protokoll.vue')

const UebSettings = () => import('@/views/zeitkontrolle/UebSettings.vue')
const HolUeb = () => import('@/views/reports/HolUeb.vue')
const MitarbeiterAuskunft = () => import('@/views/reports/MitarbeiterAuskunft.vue')
const LohnAuskunft = () => import('@/views/reports/Lohn.vue')
const LohnInterface = () => import('@/views/reports/LohnInterface.vue')


Vue.use(Router);

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      //redirect: '/',
      name: 'Personalwesen',
      component: DefaultContainer,
      children: [
        {
          path: 'bookings',
          redirect: '/bookings/calendar',
          name: 'Kalender',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: "calendar",
              name: 'Kalender',
              component: Calendar
            },
            {
              path: "holiday_calendar",
              name: 'Urlaubskalender',
              component: HolidayCalendar
            },
            {
              path: "anwesenheit",
              name: 'Anwesenheit',
              component: Anwesenheit
            },
            {
              path: "auskunft",
              name: 'Auskunft',
              component: Auskunft
            },
            {
              path: "ueberstundenverrechnung",
              name: 'Überstundenverrechnung',
              component: UebVerrechung
            },
          ],
        },
        {
          path: 'zeitkontrolle',
          redirect: '/zeitkontrolle/anwesenheit',
          name: 'Anwesenheit',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: "anwesenheit",
              name: 'Anwesenheit',
              component: Anwesenheit
            },
            {
              path: "zeiterfassung",
              name: 'Zeiterfassung',
              component: UserDay
            },
          ],
        },
        {
          path: 'reports',
          redirect: '/reports/hol_ueb',
          name: 'Auswertungen',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: "hol_ueb",
              name: 'Urlaub-/Überstundensaldo',
              component: HolUeb
            },
            {
              path: "user",
              name: 'Mitarbeiterauskunft',
              component: MitarbeiterAuskunft
            },
            {
              path: "lohn",
              name: 'Lohnarten',
              component: LohnAuskunft
            },
            {
              path: "lohn_interface",
              name: 'Schnittstelle Lohnabrechnung',
              component: LohnInterface
            },
          ],
        },
        {
          path: 'zeitkontrolle',
          redirect: '/zeitkontrolle/anwesenheit',
          name: 'Anwesenheit',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: "anwesenheit",
              name: 'Anwesenheit',
              component: Anwesenheit
            },
            {
              path: "settings",
              name: 'Einstellungen',
              component: UebSettings
            },
          ],
        },
        {
          path: 'rb',
          redirect: '/rb/raster',
          name: 'Rufbereitschaft',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: "raster",
              name: 'Raster',
              component: RufbereitschaftRaster
            },
            {
              path: "calendar",
              name: 'Kalender',
              component: RufbereitschaftCalendar
            },
            {
              path: "caller",
              name: 'Rufer',
              component: RufbereitschaftCaller
            },
            {
              path: "settings",
              name: 'Einstellungen',
              component: RufbereitschaftSettings
            },
          ],
        },
        {
          path: 'basis',
          redirect: '/basis/azra',
          name: 'Stammdaten',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: "azra",
              name: 'Arbeitszeitraster',
              component: Azra
            },
            {
              path: "azra/:id",
              name: 'Arbeitszeitraster Details',
              component: AzraDetail
            },
            {
              path: "breaks",
              name: 'Pausen',
              component: Breaks
            },
            {
              path: "kost",
              name: 'Kostenstellen',
              component: Kosts
            },
            {
              path: "migr",
              name: 'Mitarbeitergruppen',
              component: Migrs
            },
            {
              path: "mita",
              name: 'Mitarbeiter',
              component: Mitas
            },
            {
              path: "lohn",
              name: 'Lohnarten',
              component: Lohns
            },
            {
              path: "import",
              name: 'Stammdaten-Import',
              component: StammdatenImport
            },
          ],
        },
        {
          path: 'dienstplanung',
          redirect: '/dienstplanung/uebersicht',
          name: 'Dienstplanung',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            { path: 'uebersicht', name: 'Übersicht', component: DpUebersicht },
            { path: 'gruppen', name: 'Planungsgruppen', component: DpGruppen },
            { path: 'raster', name: 'Arbeitszeitraster (Referenz)', component: DpRaster },
            { path: 'rotation', name: 'Rotationsmodelle', component: DpRotation },
            { path: 'zuordnung', name: 'Musterzuordnung', component: DpZuordnung },
            { path: 'kalender', name: 'Planungskalender', component: DpKalender },
            { path: 'besetzung', name: 'Besetzung & Abdeckung', component: DpBesetzung },
            { path: 'veroeffentlichen', name: 'Prüfen & veröffentlichen', component: DpVeroeffentlichen },
            { path: 'protokoll', name: 'Protokoll', component: DpProtokoll },
            // addresses of the first, period-based version (old bookmarks / open tabs)
            { path: 'monat', redirect: '/dienstplanung/kalender' },
            { path: 'sonder', redirect: { path: '/dienstplanung/zuordnung', query: { typ: 'MACHINE' } } },
            { path: 'periode/:id', redirect: '/dienstplanung/kalender' },
          ],
        },
      ]
    },
  ]
})
